import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';

import {Result} from '@domain/common/http/result';
import {environment} from '@environments/environment';
import {Document} from "@domain/document/document";

/**
 * Service de gestion des pièces jointes avec droit utilisateur lambda
 */
@Injectable()
export class PieceJointeUserService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {}

    /**
     * Sauvegarde du type de PJ pour un document donné
     *
     * @param document Document dont modifier le type de PJ
     * @param contexte Contexte concerné
     */
    saveTypeForDocument(document: Document,contexte: string): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/PieceJointeUser/saveTypeForDocument?contexte=${contexte}`,document).pipe(first());
    }
}
